import React, { useContext } from 'react';
import {
  cardVisa,
  mastercard,
  amex,
} from '../../../../../../assets/images/Global';
import styles from '../../MethodsFlow.module.css';
import data from '../../data';
import CardForm from './components/CardForm';
import PaymentContext from '../../../../../../context/Payment/Context';

const FlowCreditCard = () => {
  const paymentContext = useContext(PaymentContext);

  const { paymentType } = paymentContext;
  const { titleCard, titleCardMonth } = data.card;

  return (
    <>
      <div className={styles.titleContainer}>
        <p className={styles.title}>
          {paymentType === 1 ? titleCard : titleCardMonth}
        </p>
        <div className={styles.logoCards}>
          <img width={24} height={24} src={cardVisa} alt="Visa" />
          <img width={24} height={24} src={mastercard} alt="Mastercard" />
          <img width={24} height={24} src={amex} alt="Amex" />
        </div>
      </div>
      <div className={styles.container}>
        <CardForm />
      </div>
    </>
  );
};

export default FlowCreditCard;
